import { React, useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useDispatch, useSelector } from "react-redux";
import { t } from "../../Helper";

import {
  setSelectedCountry,
  setSelectCountryLangCode,
  setCurrentLanguage,
  setPreferredLanguage,
  setLanguageFullName,
  setRegion,
} from "../../settingsSlice";

const WebsitePreferredLanguage = () => {
  const [selectYourCountry, setSelectYourCountry] = useState(
    "Select Website Language"
  );

  const [selectPreferredLanguage, setSelectPreferredLanguage] = useState(
    "Select Preferred Language For Your Website"
  );
  
  const {
    selectedCountry,
    selectCountryLangCode,
    preferredLanguage,
    currentLanguage,
    languageFullName,
  } = useSelector((state) => state.settings);

  const dispatch = useDispatch();
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleChange = (event) => {
    if (event.target.value!="") {
      setSelectedLanguage(event.target.value);
      dispatch(setCurrentLanguage(preferredLanguage));
      dispatch(setPreferredLanguage(event.target.value));
    } 
  };

  

  return (
    <>
      <div className="col-12 col-md-6">
        <label className="form-label section-title">
          {selectPreferredLanguage}
        </label>
        <select
          className="form-select"
          required
          id="language"
          value={selectedLanguage}
          onChange={handleChange}
        >
          <option value="">{selectYourCountry}</option>
          <option value="en">English - en</option>

          {selectCountryLangCode !== "en" && (
            <option value={selectCountryLangCode}>
              {languageFullName} - {selectCountryLangCode}
            </option>
          )}
        </select>
      </div>
    </>
  );
};

export default WebsitePreferredLanguage;
